module.exports = __webpack_public_path__ + "img/img12.ea679bc2.png";